var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Title")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("This help doc is under construction.")])])])}]

export { render, staticRenderFns }